import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Props as DumbPlayerAppearanceProps } from '#src/components/scoring/DumbPlayerAppearance/index.tsx';
import { DumbPlayerAppearance } from '#src/components/scoring/DumbPlayerAppearance/index.tsx';

import type { PlayerAppearance_anyPlayer } from './__generated__/index.graphql.ts';

type Props = {
  player: PlayerAppearance_anyPlayer;
} & Omit<DumbPlayerAppearanceProps, 'appearances'>;

export const PlayerAppearance = ({ player, mode, ...props }: Props) => {
  const appearances: number = {
    LAST_FORTY_SO5_AVERAGE_SCORE: (player.lastFortySo5Appearances || 0) / 40,
    LAST_TEN_PLAYED_SO5_AVERAGE_SCORE: (player.lastTenSo5Appearances || 0) / 10,
    LAST_FIVE_SO5_AVERAGE_SCORE: (player.lastFiveSo5Appearances || 0) / 5,
    LAST_FIFTEEN_SO5_AVERAGE_SCORE:
      (player.lastFifteenSo5Appearances || 0) / 15,
  }[mode];

  return (
    <DumbPlayerAppearance {...props} mode={mode} appearances={appearances} />
  );
};

PlayerAppearance.fragments = {
  anyPlayer: gql`
    fragment PlayerAppearance_anyPlayer on AnyPlayerInterface {
      slug
      lastFiveSo5Appearances
      lastTenSo5Appearances
      lastFifteenSo5Appearances
      lastFortySo5Appearances
    }
  ` as TypedDocumentNode<PlayerAppearance_anyPlayer>,
};
